import React from "react";
import { connect } from "react-redux";
import cs from "classnames";
import format from "date-fns/format";

import mapDispatch from "~/misc/mapDispatch";
import { formatTimeDuration } from "~/misc/dates";

import {
  getPostTruckListAction,
  changShowCardAction,
  selectedPostTruckAction,
  deletePostTruckAction,
  deletePostTrucksAction,
  clearFormAction,
  setRateAction,
} from "../../state/action";

import {
  SORTTYPE,
  ORDERTYPE,
  POSTTRUCKSHOWTYPE,
  CalculateWeightType,
  FREQUENCY,
  LISTFREQUENCYSHOW,
  WEEKLYPOSTDATA,
  LOADSIZESHOW,
} from "../../utils";

import deleteImg from "../../../../../assets/posttruck/delete.svg";
import copyImg from "../../../../../assets/posttruck/copy.svg";
import editImg from "../../../../../assets/posttruck/edit.svg";
import checkboxImg from "../../../../../assets/posttruck/checkbox.svg";
import checkboxSelctedImg from "../../../../../assets/posttruck/checkbox-select.svg";
import refreshImg from "../../../../../assets/posttruck/refresh.svg";
import ageImg from "../../../../../assets/posttruck/age.svg";
import sortArraowImg from "../../../../../assets/posttruck/sortArrow.svg";
import listnoneImg from "../../../../../assets/posttruck/listnone.svg";
import delwarning from "../../../../../assets/posttruck/delwarning.svg";

import css from "./style.css";

const defaultPagePR = {
  page: 0,
  pageSize: 10,
  sortBy: SORTTYPE.AGE,
  order: ORDERTYPE.DESC,
};

const AZIcon = () => (
  <span>
    <p>A</p>
    <p>Z</p>
  </span>
);

let toggleListDelPanel = null;

class PostTruckList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      listSum: 0,
      listMore: false,
      listPages: 0,
      selectedListCount: 0,
      ...defaultPagePR,
      selectedAll: false,
      showDeletePanel: false,
    };

    toggleListDelPanel = () => this.toggleDelPanel(this);
  }
  componentWillMount() {
    if (this.props.user.id && !this.verifyAccount(this.props.user)) {
      this.props.changeShowCard(POSTTRUCKSHOWTYPE.GUID_NOVERIFY);
      return;
    }
    this.getShowList(defaultPagePR);
  }
  componentWillReceiveProps(nextProps) {
    let { list } = this.state;
    let setList = false;
    if (
      this.props.addPostTruck &&
      nextProps.addPostTruck &&
      this.props.addPostTruck.id !== nextProps.addPostTruck.id
    ) {
      list.unshift(nextProps.addPostTruck);
      setList = true;
    }
    if (
      this.props.updatePostTruck &&
      nextProps.updatePostTruck &&
      this.props.updatePostTruck.id !== nextProps.updatePostTruck.id
    ) {
      const index = list.findIndex(
        (item) => item.id === nextProps.deletePostTruck.id
      );
      const formatData = this.formateListData([nextProps.deletePostTruck])[0];
      list.splice(index, 1, formatData);
      setList = true;
    }
    if (setList) {
      list = this.formateListData(list);
      this.setState({ list });
    }
  }
  render() {
    return (
      <section className={css.postTuckList}>
        <header className={css.postTuckListHeaderTab}>
          <div className={css.tabItem}>Truck Post</div>
        </header>
        <main className={css.postTuckListMain}>
          <header className={css.postTuckListBodyHeader}>
            <div className={css.headerActions}>
              <div className={css.sortActions}>
                <button
                  className={cs(css.sortActionItem, {
                    [css.sortActionItemSelected]:
                      this.state.sortBy === SORTTYPE.AGE,
                    [css.sortAsc]:
                      this.state.sortBy === SORTTYPE.AGE &&
                      this.state.order === ORDERTYPE.ASC,
                  })}
                  onClick={() => this.changSort(SORTTYPE.AGE)}
                >
                  Age{sortArraowImg()}
                </button>
                <button
                  className={cs(css.sortActionItem, {
                    [css.sortActionItemSelected]:
                      this.state.sortBy === SORTTYPE.PICKUP,
                    [css.sortAsc]:
                      this.state.sortBy === SORTTYPE.PICKUP &&
                      this.state.order === ORDERTYPE.DESC,
                  })}
                  onClick={() => this.changSort(SORTTYPE.PICKUP)}
                >
                  Origin{sortArraowImg()}
                  <AZIcon />
                </button>
                <button
                  className={cs(css.sortActionItem, {
                    [css.sortActionItemSelected]:
                      this.state.sortBy === SORTTYPE.EQUIPMENT,
                    [css.sortAsc]:
                      this.state.sortBy === SORTTYPE.EQUIPMENT &&
                      this.state.order === ORDERTYPE.DESC,
                  })}
                  onClick={() => this.changSort(SORTTYPE.EQUIPMENT)}
                >
                  Trailer Type{sortArraowImg()}
                  <AZIcon />
                </button>
                <button
                  className={cs(css.sortActionItem, {
                    [css.sortActionItemSelected]:
                      this.state.sortBy === SORTTYPE.DROP_OFF,
                    [css.sortAsc]:
                      this.state.sortBy === SORTTYPE.DROP_OFF &&
                      this.state.order === ORDERTYPE.DESC,
                  })}
                  onClick={() => this.changSort(SORTTYPE.DROP_OFF)}
                >
                  Destination{sortArraowImg()}
                  <AZIcon />
                </button>
              </div>
              <button
                className={css.postTruckBtn}
                onClick={() => this.showDetail(POSTTRUCKSHOWTYPE.DETAIL_CREATE)}
              >
                <span>+</span>Post Truck
              </button>
            </div>
            <div className={css.headerActions}>
              <div className={css.headerListActions}>
                <div
                  className={css.selectedCount}
                  onClick={() => this.selectedAll(true)}
                >
                  {this.state.selectedAll
                    ? checkboxSelctedImg()
                    : checkboxImg()}
                  <span className={css.selectedNumber}>
                    {this.state.selectedListCount}
                  </span>
                  <span>selected</span>
                </div>
                <div
                  className={cs(css.selectedDelete, {
                    [css.selectedDeleteDisable]:
                      this.state.selectedListCount === 0,
                  })}
                  onClick={() =>
                    this.state.selectedListCount > 0 &&
                    this.toggleDelPanel(this)
                  }
                >
                  {deleteImg()}
                  Delete
                </div>
                {/* <div
                  className={css.listRefresh}
                  onClick={() => this.refreshList()}
                >
                  {refreshImg()}
                  Refresh
                </div> */}
                {this.state.showDeletePanel && (
                  <div className={css.deletePanel}>
                    {delwarning()}
                    Are you sure to delete selected item？
                    <div className={css.delPanelBtns}>
                      <button
                        className={css.cancel}
                        onClick={() => this.toggleDelPanel(this, false)}
                      >
                        Cancel
                      </button>
                      <button
                        className={css.del}
                        onClick={() => this.delListItem()}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </header>
          <div className={css.postTuckListBody}>
            {this.state.list.length === 0 ? (
              <div className={css.listNoneImg}>{listnoneImg()}</div>
            ) : (
              this.state.list.map((item, index) => {
                return (
                  <div
                    className={css.listItem}
                    key={item.id + Math.random()}
                    onMouseLeave={() => this.toggleListDelPanel(item, false)}
                  >
                    <div className={css.listItemCheckbox}>
                      <span onClick={() => this.listItemSelect(item)}>
                        {item.selected ? checkboxSelctedImg() : checkboxImg()}
                      </span>
                    </div>
                    <div className={css.listItemContent}>
                      <div className={css.contentHeader}>
                        <span className={cs(css.origin, css.location)}>
                          {item.pickup.address}
                        </span>
                        <span className={css.deadhead}>
                          ({item.pickup.deadhead}mi)
                        </span>
                        <span className={css.lightFont}>→</span>
                        <span className={cs(css.destination, css.location)}>
                          {item.dropoff.address}
                        </span>
                        <span className={css.deadhead}>
                          ({item.dropoff.deadhead}mi)
                        </span>
                        <div className={css.listItemAtcions}>
                          <button
                            className={cs(css.itemDelete, css.itemBtn)}
                            // onClick={() => this.deletePostTruck(item)}
                            onClick={() => this.toggleListDelPanel(item)}
                          >
                            {deleteImg()}
                            <span>Delete</span>
                          </button>
                          <button
                            className={cs(css.itemCopy, css.itemBtn)}
                            onClick={() =>
                              this.showDetail(
                                POSTTRUCKSHOWTYPE.DETAIL_COPY,
                                item
                              )
                            }
                          >
                            {copyImg()}
                            <span>Copy</span>
                          </button>
                          <button
                            className={cs(css.itemEdit, css.itemBtn)}
                            onClick={() =>
                              this.showDetail(
                                POSTTRUCKSHOWTYPE.DETAIL_EDIT,
                                item
                              )
                            }
                          >
                            {editImg()}
                            <span>Edit</span>
                          </button>
                        </div>
                      </div>
                      <div className={css.contentBody}>
                        <div className={cs(css.frequency, css.contentItem)}>
                          <div className={css.contentItemHeader}>
                            <span>{item.frequency}</span>
                          </div>
                          <div
                            className={css.contentItemBody}
                            onMouseOver={() =>
                              this.toggleListTooltip("over", index)
                            }
                            onMouseLeave={() =>
                              this.toggleListTooltip("out", index)
                            }
                          >
                            {item.frequencyDate}
                          </div>
                        </div>
                        <div className={cs(css.trailer, css.contentItem)}>
                          <div className={css.contentItemHeader}>
                            <span>TRAILER TYPE</span>
                          </div>
                          <div className={css.contentItemBody}>
                            {item.equipment.toUpperCase()}
                          </div>
                        </div>
                        <div className={cs(css.others, css.contentItem)}>
                          <div className={css.contentItemHeader}>
                            <span>OTHERS</span>
                          </div>
                          <div className={css.contentItemBody}>
                            {`${item.loadSizeShow} · ${item.lengthShow} · ${item.weight}`}
                          </div>
                        </div>
                        <div className={cs(css.age, css.contentItem)}>
                          <div className={css.contentItemHeader}>
                            <span>AGE</span>
                          </div>
                          <div className={css.contentItemBody}>
                            {ageImg()}
                            {item.age}
                          </div>
                        </div>
                        <div className={cs(css.rate, css.contentItem)}>
                          <div className={css.contentItemHeader}>
                            <span>RATE</span>
                          </div>
                          <div className={css.contentItemBody}>
                            <b>${item.desiredRate}</b>
                            <span>/mile</span>
                          </div>
                        </div>
                      </div>
                      <span
                        className={css.contentItemBodyToolTip}
                        ref={(node) => this.saveNode(node, index)}
                      >
                        {item.frequencyDate}
                      </span>
                      {item.showDelPanel && (
                        <div
                          className={css.deletePanel}
                          onMouseLeave={() =>
                            this.toggleListDelPanel(item, false)
                          }
                        >
                          {delwarning()} Are you sure to delete this item？
                          <div className={css.delPanelBtns}>
                            <button
                              className={css.cancel}
                              onClick={() =>
                                this.toggleListDelPanel(item, false)
                              }
                            >
                              Cancel
                            </button>
                            <button
                              className={css.del}
                              onClick={() => this.deletePostTruck(item)}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </main>
        {this.state.listMore && (
          <footer className={css.postTruckFooter}>
            <div
              className={css.listShowMorr}
              onClick={() =>
                this.changPage(this.state.page + 1, this.state.pageSize)
              }
            >
              Show {this.state.pageSize} More
            </div>
          </footer>
        )}
      </section>
    );
  }
  toggleDelPanel(_this, show) {
    const showPanel = show === undefined ? !_this.state.showDeletePanel : show;
    if (showPanel) {
      document.addEventListener("click", toggleListDelPanel);
    } else {
      document.removeEventListener("click", toggleListDelPanel);
    }
    _this.setState({ showDeletePanel: showPanel });
  }
  selectedAll(actList) {
    let { list, selectedAll, selectedListCount } = this.state;
    selectedAll = !selectedAll;
    if (actList) {
      list.forEach((item) => {
        item.selected = selectedAll;
      });
      selectedListCount = selectedAll ? list.length : 0;
    }
    this.setState({
      list,
      selectedAll,
      selectedListCount,
    });
  }
  listItemSelect(item) {
    let { selectedListCount, list, selectedAll } = this.state;
    item.selected = !item.selected;
    list.splice(list.indexOf(item), 1, item);
    const selectedList = list.filter((item) => item.selected);
    selectedListCount = selectedList.length;
    selectedAll = selectedListCount === list.length ? true : false;
    this.setState({ selectedListCount, list, selectedAll });
  }
  saveNode(node, id) {
    this.listTooltip = this.listTooltip
      ? {
          ...this.listTooltip,
          [id]: node,
        }
      : {
          [id]: node,
        };
  }
  toggleListTooltip(type, id) {
    if (type === "over")
      this.listTooltip[
        id
      ].className = `${css.contentItemBodyToolTip} ${css.contentItemBodyToolTipShow}`;
    if (type === "out")
      this.listTooltip[id].className = `${css.contentItemBodyToolTip}`;
  }
  refreshList() {
    const newPageData = {
      page: defaultPagePR.page,
      pageSize: defaultPagePR.pageSize,
      sortBy: defaultPagePR.sortBy,
      order: defaultPagePR.order,
    };
    this.setState({
      ...newPageData,
    });
    this.getShowList(
      {
        ...newPageData,
      },
      "refresh"
    );
  }
  changSort(sortBy) {
    const setData = {
      sortBy: sortBy,
      order: this.state.order,
      page: defaultPagePR.page,
      pageSize: defaultPagePR.pageSize,
    };
    if (this.state.sortBy === setData.sortBy) {
      setData.order =
        this.state.order === ORDERTYPE.DESC ? ORDERTYPE.ASC : ORDERTYPE.DESC;
    } else {
      setData.order =
        setData.sortBy === SORTTYPE.AGE ? ORDERTYPE.DESC : ORDERTYPE.ASC;
    }
    this.setState(setData);
    this.getShowList(
      {
        ...setData,
      },
      "refresh"
    );
  }
  changPage(page, pageSize) {
    this.setState({ page: page, pageSize: pageSize });
    this.getShowList({
      page: page,
      pageSize: pageSize,
      sortBy: SORTTYPE.AGE,
      order: ORDERTYPE.DESC,
    });
  }
  getShowList(getData, type) {
    this.props.getList(getData).then((res) => {
      if (!res) return;
      const formateList = this.formateListData(res.data.resultList || []);
      this.setState({
        list:
          type === "refresh"
            ? formateList
            : this.state.list.concat(formateList),
        listSum: res.data.total,
        listMore: res.data.more,
        listPages: res.data.totalPage,
      });
    });
  }
  formateListData(list) {
    return list.map((item) => {
      item.weight = CalculateWeightType(item.weightMin, item.weightMax);
      // item.loadSize = item.loadSize
      //   ? `${item.loadSize[0].toUpperCase()}${item.loadSize.substring(1)}`
      //   : "Any";
      item.loadSizeShow = LOADSIZESHOW[item.loadSize]
        ? LOADSIZESHOW[item.loadSize]
        : "FTL+LTL";
      item.lengthShow = item.length === 0 ? "Any" : `${item.length}ft`;
      item.selected = false;
      item.showDelPanel = false;
      item.frequency = FREQUENCY[item.recurring.type];
      switch (item.recurring.type) {
        case FREQUENCY["One Time"]:
          item.frequencyDate = `${format(
            new Date(item.recurring.dates[0]),
            "YYYY/MM/DD"
          )} - ${format(new Date(item.recurring.dates[1]), "YYYY/MM/DD")}`;
          break;
        case FREQUENCY["Recurring Weekly"]:
          item.frequencyDate = `${LISTFREQUENCYSHOW[item.recurring.type]} ${
            item.recurring.dates
              ? item.recurring.dates.map((d) => WEEKLYPOSTDATA[d]).join(",")
              : ""
          }`;
          break;
        case FREQUENCY["Recurring Daily"]:
        case FREQUENCY["Recurring Monthly"]:
          item.frequencyDate = `${LISTFREQUENCYSHOW[item.recurring.type]} ${
            item.recurring.dates ? item.recurring.dates.join(",") : ""
          }`;
          break;
        default:
          break;
      }
 
      item.age = formatTimeDuration(new Date().getTime() - item.updatedAt);
      return item;
    });
  }
  verifyAccount(data) {
    //email phone  dot mc
    // return false;
    return (
      data.emailVerified &&
      data.verified_phone &&
      data.dot_verified &&
      data.mc_verified
    );
  }
  showDetail(type, item) {
    if (!item) {
      this.props.clearFrom();
    }
    this.props.setRate(item && item.desiredRate ? item.desiredRate : "");
    this.props.selectPostTruck(item);
    this.props.changeShowCard(type);
  }
  delListItem() {
    const newList = [];
    const ids = [];
    this.state.list.forEach((item) => {
      if (item.selected) {
        ids.push(item.id);
      } else {
        newList.push(item);
      }
    });
    this.props.delPostsTruck(ids).then((res) => {
      if (!res) return;
      this.toggleDelPanel(this, false);
      this.setState({
        list: newList,
      });
    });
  }
  deletePostTruck(item) {
    this.props.delPostTruck(item.id).then((res) => {
      if (!res) return;
      const newList = this.state.list;
      newList.splice(newList.indexOf(item), 1);
      this.setState({
        list: newList,
      });
    });
  }
  toggleListDelPanel(item, show) {
    item.showDelPanel = show === undefined ? !item.showDelPanel : show;
    this.state.list.splice(this.state.list.indexOf(item), 1, item);
    this.setState(this.state.list);
  }
}

export default connect(
  (state, ownProps) => {
    return {
      user: state.user,
      ...state.postTruck,
      ...ownProps,
    };
  },
  mapDispatch({
    changeShowCard: (props, type) => changShowCardAction(type),
    getList: (props, data) => getPostTruckListAction(data),
    selectPostTruck: (props, data) => selectedPostTruckAction(data),
    setRate: (props, rate) => setRateAction(rate),
    delPostTruck: (props, id) => deletePostTruckAction(id),
    delPostsTruck: (props, ids) => deletePostTrucksAction(ids),
    clearFrom: () => clearFormAction(),
  })
)(PostTruckList);



// WEBPACK FOOTER //
// ./src/pages/PostTruck/compontents/PostTruckList/index.js